import { RCBanner } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import DocumentBrandIcon from '@reverbdotcom/cadence/images/brand/document-orange.svg';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';

interface Props {
  taxType: string;
  countryCode: string;
}

export function InternationalTaxIdBanner({ taxType, countryCode }: Props) {
  const collectingSellerServicesTaxInAu = useExpEnabled(experiments.COLLECT_TAX_ON_AU_SELLER_FEES);
  const auTitle = collectingSellerServicesTaxInAu ? 'auTaxTitle' : 'upcomingAuTaxTitle';

  const collectingSellerServicesTaxInUk = useExpEnabled(experiments.COLLECT_TAX_ON_UK_SELLER_FEES);
  const ukTitle = collectingSellerServicesTaxInUk ? 'ukTaxTitle' : 'upcomingUkTaxTitle';

  const title = countryCode === 'AU' ? auTitle : ukTitle;

  return (
    <>
      { countryCode ? (
        // banner for UK and AU sellers
        <RCBanner
          title={I18n.t(`discovery.internationalTaxIds.banner.${title}`)}
          content={
            <Translate text="discovery.internationalTaxIds.banner.auAndUkContent">
              <Translate text={`discovery.internationalTaxIds.banner.${taxType}`} />
            </Translate>
          }
          image={DocumentBrandIcon}
          cta={<CoreLink to="/my/selling/tax_policy"><Translate text="discovery.internationalTaxIds.banner.buttonText" /></CoreLink>}
        />
      ) : (
        // banner for EU sellers
        <RCBanner
          title=""
          content={
            <Translate text="discovery.internationalTaxIds.banner.euAddTaxId">
              <Translate text={`discovery.internationalTaxIds.banner.${taxType}`} />
            </Translate>
          }
          image={DocumentBrandIcon}
          cta={<CoreLink to="/my/selling/tax_policy"><Translate text="discovery.internationalTaxIds.banner.buttonText" /></CoreLink>}
        />
      )}
    </>
  );
}

export default InternationalTaxIdBanner;
